import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BookmarkService } from '../../../services/bookmark.service';
@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
  styleUrl: './card.component.css'
})
export class CardComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @Input() index!: number;
  @Output() selectedID: EventEmitter<{id: string, outcome?: string}> = new EventEmitter();
  @Output() bookmarkToggled: EventEmitter<{ cardId: string; isBookmarked: boolean }> = new EventEmitter();
  
  isBookmarked: boolean = false;
  private bookmarkSubscription: Subscription | undefined;

  constructor(private bookmarkService: BookmarkService) {}

  ngOnInit(): void {
    // Initialize bookmark state from service
    this.isBookmarked = this.bookmarkService.isBookmarked(this.data.id);
    
    // Subscribe to bookmark changes
    this.bookmarkSubscription = this.bookmarkService.bookmarkedMarkets$.subscribe(() => {
      this.isBookmarked = this.bookmarkService.isBookmarked(this.data.id);
    });
  }

  ngOnDestroy(): void {
    if (this.bookmarkSubscription) {
      this.bookmarkSubscription.unsubscribe();
    }
  }

  getProgressPercentage(percent: any): number {
    if (percent === undefined || percent === null) return 50;

    // Convert percentage string to number (remove % sign if present)
    const percentValue = typeof percent === 'number' ? percent : parseInt(String(percent).replace('%', '')) || 50;
    // Ensure it's between 0 and 100
    return Math.min(100, Math.max(0, percentValue));
  }

  getIndicatorColor(percent: any): string {
    const value = this.getProgressPercentage(percent);
    return value < 50 ? '#DBA900' : '#1CAE91';
  }

  openCard() {
    this.data.showNested = true;
    this.data.hideMain = true;
  }

  closeCard() {
    this.data.showNested = false;
    this.data.hideMain = false;
  }

  get isLastInRow() {
    return (this.index + 1) % 4 === 0; // 4 cards per row
  }

  isAnyOptionActive(): boolean {
    return this.data.options.some((option: any) => option.showNested);
  }

  // Method to handle team selection
  selectTeam(team: string) {
    if (this.data.cardType === 'sports') {
      this.data.selectedOption = team;
    }
  }

  // Optional: Method to get team short name
  getTeamShortName(fullName: string): string {
    // Extract short name (e.g., "Liverpool FC" -> "Liverpool")
    return fullName?.split(' ')[0] || fullName;
  }



  toggleOptionYes(optionIndex: number) {
    // Hide all other options and show only the clicked one
    this.data.options.forEach((option: any, index: number) => {
      if (index === optionIndex) {
        option.showNested = true;
        option.hideMain = true;
      } else {
        option.showNested = false;
        option.hideMain = false; // Or true if you want to hide others completely
      }
    });
  }

  toggleOptionNo(optionIndex: number) {
    // Same logic for No button if needed
    this.toggleOptionYes(optionIndex);
  }
  
  toggleOption(index: number) {
    const element = event?.target as HTMLElement;

    if (element.classList.contains('yes')) {
      this.toggleOptionYes(index);
    }
    else if (element.classList.contains('no')) {
      this.toggleOptionNo(index);
    }
    else {
      // Default Yes if clicked between? Optional:
      this.toggleOptionYes(index);
    }
  }

  closeOptionNested(optionIndex: number) {
    // Reset all options to default state
    this.data.options.forEach((option: any) => {
      option.showNested = false;
      option.hideMain = false;
    });
  }

  selectedCard(id: string, outcome?: string): void {
    this.selectedID.emit({id, outcome})
  }

  toggleBookmark(event: Event): void {
    event.stopPropagation();
    this.bookmarkService.toggleBookmark(this.data.id);
    // isBookmarked will be updated via the subscription
    this.bookmarkToggled.emit({
      cardId: this.data.id,
      isBookmarked: !this.isBookmarked
    });
  }
}